export default __webpack_public_path__ + "static/media/palm-tree-sky.b16df2d1.jpg";